import React, {useState, useEffect} from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: theme.palette.common.black,
    textAlign: 'center',
  },
  body: {
    fontSize: '14px',
  },
}))(TableCell);

const ClickableTableCell = withStyles((theme) => ({
  body: {
    border: ' 1px solid rgb(15, 45, 170)',
    textAlign: 'center',
    fontSize: '11px',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    textAlign: 'center',
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  emptyCell: {
    border: 'none',
    textAlign: 'left',
  },
  active: {
    backgroundColor: 'rgb(15, 45, 170)',
    color: 'white',
    boxShadow: '3px 3px 3px black',
  },
  inactive: {
    backgroundColor: 'transparent',
  },
});

export default function EvalTable(props) {
  const classes = useStyles();
  const initialValues = props.initialValues
  const onUpdateRisk = props.onUpdateRisk
  const onCalcRisk = props.onCalcRisk
  const [rowsStatus, setRowsStatus] = useState(initialValues)

  /// [[pergunta, valor se positivo]]
  const rows = props.rows

  function handleClickCol1(index, value, col){
    if (col === 1 && !rowsStatus[index]) {
      let newArr = [...rowsStatus]
      newArr[index] = value
      setRowsStatus(newArr)
    }
    if (col === 2 && rowsStatus[index]) {
      let newArr = [...rowsStatus]
      newArr[index] = 0
      setRowsStatus(newArr)
    }
  }

  useEffect(()=>{
    onUpdateRisk(rowsStatus)
    onCalcRisk(rowsStatus)
  },[rowsStatus])

  useEffect(()=>{
    setRowsStatus(initialValues)
  },[initialValues])


  return (
    <div>
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell className={classes.emptyCell}><b>Ao lado de cada pergunta, responda "SIM" ou "NÃO" ➝ ➞ ➔ ➜ </b></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <StyledTableRow key={row[0]}>
              <StyledTableCell component="th" scope="row">
                {row[0]}
              </StyledTableCell>
              <ClickableTableCell className={rowsStatus[index] ? classes.active : classes.inactive} onClick={()=>{handleClickCol1(index, row[1], 1)}}>SIM</ClickableTableCell>
              <ClickableTableCell className={rowsStatus[index] ? classes.inactive : classes.active} onClick={()=>{handleClickCol1(index, row[1], 2)}}>NÃO</ClickableTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
      </TableContainer>
      </div>
  );
}
